export default function($form) {
    $('#country', $form).on('change', function() {
        const code = $(this).val();

        if (code == 'au') {
            $('#state', $form).hide();
            $('#state_select', $form).show();
            $('#state', $form).closest('.form-group').find('label span.text-red').removeClass('d-none');
        }
        else {
            $('#state', $form).show();
            $('#state_select', $form).hide();
            $('#state', $form).closest('.form-group').find('label span.text-red').addClass('d-none');
        }
    });

    $('#state', $form).closest('.form-group').find('label span.text-red').addClass('d-none');
    const country = $('#country', $form).val();
    if (!country) {
        $('#country', $form).val('au');
    }
    $('#country', $form).trigger('change');
}


// WEBPACK FOOTER //
// ./scripts/util/stateAndCountry.js